/**
 * King Living video preset extensions.
 * Resolved via package overlay when `@amblique/base/app/constants/video-options` is imported.
 */

import {VIDEO_OPTIONS as BASE_VIDEO_OPTIONS} from '@amblique/base/app/constants/video-options';

export const VIDEO_OPTIONS = {
  ...BASE_VIDEO_OPTIONS,

  /**
   * Decorative videos inside Contentful Media Carousel (CF-016 / collection rail).
   * Contentful Video `presets` and `options` on the entry override these defaults.
   */
  mediaCarousel: {
    background: true,
    controls: false,
    readonly: true,
    autopilot: true,
    loop: true,
    mute: true,
    muted: true,
    size: 'cover',
  },
};

export {VIDEO_AUTOPILOT_BEHAVIORS} from '@amblique/base/app/constants/video-options';
